/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-03-16
 */

import * as Vue from 'vue-tsx-support';
import { Component } from 'vue-property-decorator';
import './hexFile.less'
import { createNamespace, createBEM } from 'src/util/bem';
import FrameSideBg from 'src/pages/layout/components/frameSideBg';
import HexFileApi, { HexFileDOI } from './api/hexFileApi';
import { CommonUtil } from 'src/util/commonUtil';
import AgGridVueCustomTsx, { ColDefCustom } from 'src/components/agGridCustom/agGridVueCustomTsx';
import { GridOptions } from 'ag-grid-community';
import CellOperate from 'src/components/agGridComponent/cellOperate';
import { Toast } from 'src/util/toast';
import Button from 'src/types/iview/Button';
import EnumOperates from 'src/enums/enumOperates';
import alertHexFileOperateModal from './hexFileOperateModal';
import alertHexFilesOperateModal from './hexFilesOperateModal';
import EnumFileType from 'src/enums/enmuFileType';
let bem = createBEM('hexfile-config');

@Component({ name: 'hexfile-config' })
export default class HexFile extends Vue.Component<any>{
    data: any = [];

    currentCatalogueTree!: HexFileDOI.HexFile;
    rowData: HexFileDOI.RowDataI[] = [];
    gridOptions: GridOptions = {};
    columnDefs: ColDefCustom[] = [];

    showButton!: boolean = true;

    async queryAll() {
        let { code, data } = await HexFileApi.searchCatalogueTree();
        if (code === 0) {
            CommonUtil.treeForEach(
                data,
                (i: any) => {
                    i.title = i.name;
                    i.children = i.children_list;
                    i.expand = true;
                    if(this.currentCatalogueTree && this.currentCatalogueTree.id === i.id) {
                        i.selected = true
                    }
                },
                'children_list',
            );
            if (data[0]) {
                this.data = data;
            }
        }
    }

    async selectChange(i) {
        this.currentCatalogueTree = i[0];
        if(this.currentCatalogueTree.type == 2)
        {
           this.showButton = false;
        }
        else{
            this.showButton = true;
            this.queryById();
        }
    }

    async queryById() {
        let { code, data } = await HexFileApi.parentIdByChild(this.currentCatalogueTree.id);
        if (code === 0) {
            this.rowData = data;
        }
    }

    async add() {
        let res = await alertHexFileOperateModal(EnumOperates.Add.getName(), this.currentCatalogueTree);
        if (res) {
            this.queryById();
            this.queryAll()
        }
    }
    
    //添加文件
    async addFile(){
        let res = await alertHexFilesOperateModal(EnumOperates.Add.getName(), this.currentCatalogueTree);
        if (res) {
            this.queryById();
            this.queryAll()
        }
    }

    async mounted() {
        await this.queryAll();
        // @ts-ignore
        this.data[0].selected = true;
        this.currentCatalogueTree = this.data[0];
        this.selectChange([this.data[0]]);
        this.data = JSON.parse(JSON.stringify(this.data))
    }
    
    created() {
        let t = this
        this.columnDefs = [
            {
                headerName: '名称',
                field: 'name',
                minWidth: 140,
            },
            {
                headerName: '文件类型',
                field: 'type',
                minWidth: 140,
                cellRenderer(params) {
                    let data: HexFileDOI.RowDataI = params.data;
                    return EnumFileType.findId(data.type).getName();
                },
            },
            {
                headerName: '文件版本说明',
                field: 'file_version',
                minWidth: 140,
            },
            {
                headerName: '操作',
                field: 'operate',
                minWidth: 160,
                maxWidth: 160,
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                        text: '修改',
                        disabled(params) {
                            let data: HexFileDOI.RowDataI = params.data;
                            return data.type == 2;
                        },
                        click: async params => {
                            let data: HexFileDOI.RowDataI = params.data;
                            let res = await alertHexFileOperateModal(EnumOperates.Update.getName(), this.currentCatalogueTree, data);
                            if (res) {
                                this.queryById();
                                this.queryAll()
                            }
                        },
                    },
                    {
                        text: '删除',
                        click: async params => {
                            let res = await Toast.confirm();
                            if (!res) {
                                return;
                            }
                            let data: HexFileDOI.RowDataI = params.data;
                            let { code } = await HexFileApi.delete(data.id);
                            if (code === 0) {
                                this.queryById();
                                this.queryAll()
                            }
                        },
                    },
                ],
            },
        ];
    }

    render(h) {
        return (
            <layout class={bem()}>
                <sider hide-trigger width={372} class={createNamespace('pa6')}>
                    <FrameSideBg style="height: 100%">
                        <div class={bem('left-menu')}>
                            <div class={bem('left-menu-title')}>目录列表</div>
                            <div class={bem('left-menu-tree')}>
                                <tree ref="tree" class={bem()} data={this.data} on-on-select-change={this.selectChange.bind(this)} />
                            </div>
                        </div>
                    </FrameSideBg>
                </sider>
                <i-content class={bem('content') + ' ' + createNamespace('pa6')}>
                    <div class={bem('right-menu')}>
                        <div class={bem('right-menu-title')}>
                            下级目录
                            <Button type="primary" on-click={this.add.bind(this)} v-if={this.showButton}>
                                新增目录
                            </Button>
                            <Button type="primary" on-click={this.addFile.bind(this)} style="margin-right: 10px;" v-if={this.showButton}>
                                新增文件
                            </Button>
                        </div>
                        <AgGridVueCustomTsx
                            class={bem('right-menu-tb')}
                            gridOptions={this.gridOptions}
                            columnDefs={this.columnDefs}
                            rowData={this.rowData}
                            enableServerSideSorting={false}
                            checkBoxShow={false}
                            pageShow={false}
                        />
                    </div>
                </i-content>
            </layout>
        );
    }
}